import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";
import {ObjectFactory} from "@commons/types";
import {TabellaArrotondamentiRecord} from "@commons/mapping/TabellaArrotondamentiRecord";
import {merge} from "lodash";

export type TipoArrotondamento = "MINUTARIO" | "AL_QUARTO" | "ALLA_MEZZA" | "DA_TABELLA" | "AL_QUINTO" | "AL_DECIMO";
export type AzionePerPausaSenzaTimbrature = "DECURTA_MIN_PAUSA" | "DECURTA_MAX_PAUSA" | "NESSUNA_OPERAZIONE";

function _getMinArrotondamento(tipoArrotondamento: TipoArrotondamento | null): 15 | 1 | 30 | 10 | 5 {
    if (tipoArrotondamento) {
        if (tipoArrotondamento === 'DA_TABELLA') {
            return 15;
        } else if (tipoArrotondamento === 'MINUTARIO') {
            return 1;
        } else if (tipoArrotondamento === 'AL_QUARTO') {
            return 15;
        } else if (tipoArrotondamento === 'ALLA_MEZZA') {
            return 30;
        } else if (tipoArrotondamento === 'AL_DECIMO') {
            return 10;
        } else if (tipoArrotondamento === 'AL_QUINTO') {
            return 5;
        }
    }
    return 15; // Default???
}

interface Giustificazione {
    codGiu: string;
    quantita: number;
}

export interface TurnoDistribuzioneRecord extends URIAndTrace {
    idAziendaTabelle: number;
    codTurno: number;
    idGiorno: number;
    descrizione: string;
    descrizioneTurno: string;
    hhPreviste: number;
    previstoModificabile: boolean;
    sestoGiorno: boolean;
    settimoGiorno: boolean;
    prima: CoppiaTimbrature | null;
    seconda: CoppiaTimbrature | null;
    terza: CoppiaTimbrature | null;
    quarta: CoppiaTimbrature | null;
    minMinutiPausa: number;
    maxMinutiPausa: number;
    incrementoPausa: number;
    pausa: CoppiaTimbrature | null;
    tipoArrotondamentoPausa: TipoArrotondamento | null;
    idTabArrotondamentiPausa: number;
    decurtaPausa: boolean;
    segnalaMancataPausa: boolean;
    giustHH1: Giustificazione | null;
    giustHH2: Giustificazione | null;
    giustQI1: Giustificazione | null;
    giustQI2: Giustificazione | null;
    tipoArrotondamento: TipoArrotondamento | null;
    idTabArrotondamenti: number;
    tipoArrotondamentoUscita: TipoArrotondamento | null;
    idTabArrotondamentiUscita: number;
    tipoArrotondamentoInfragiornaliero: TipoArrotondamento | null;
    idTabArrotondamentiInfragiornaliero: number;
    azionePerPausaSenzaTimbrature: AzionePerPausaSenzaTimbrature | null;

    tabArrotondamenti?: TabellaArrotondamentiRecord | null; // solo ad uso frontend, dal backend vengono ignorati!
    tabArrotondamentiUscita?: TabellaArrotondamentiRecord | null; // solo ad uso frontend, dal backend vengono ignorati!
    tabArrotondamentiPausa?: TabellaArrotondamentiRecord | null; // solo ad uso frontend, dal backend vengono ignorati!
    tabArrotondamentiInfragiornaliero?: TabellaArrotondamentiRecord | null; // solo ad uso frontend, dal backend vengono ignorati!

    bgColor: string | null,
}

export class TurnoDistribuzioneRecord {

    static factory: ObjectFactory<TurnoDistribuzioneRecord> = (json?) => {
        return merge<TurnoDistribuzioneRecord, Partial<TurnoDistribuzioneRecord> | undefined>({
            idAziendaTabelle: 0,
            codTurno: 0,
            idGiorno: 0,
            descrizione: '',
            descrizioneTurno: '',
            hhPreviste: 0,
            previstoModificabile: true,
            sestoGiorno: false,
            settimoGiorno: false,
            prima: null,
            seconda: null,
            terza: null,
            quarta: null,
            minMinutiPausa: 0,
            maxMinutiPausa: 0,
            incrementoPausa: 0,
            pausa: null,
            tipoArrotondamentoPausa: null,
            idTabArrotondamentiPausa: 0,
            decurtaPausa: false,
            segnalaMancataPausa: true,
            giustHH1: null,
            giustHH2: null,
            giustQI1: null,
            giustQI2: null,
            tipoArrotondamento: null,
            idTabArrotondamenti: 0,
            tipoArrotondamentoUscita: null,
            idTabArrotondamentiUscita: 0,
            tipoArrotondamentoInfragiornaliero: null,
            idTabArrotondamentiInfragiornaliero: 0,
            azionePerPausaSenzaTimbrature: null,
            insertTrace: undefined,
            lastUpdateTrace: undefined,
            bgColor: null,
            URI: null,
        }, json);
    }


    static isArrotondamentoDaTabella = (distribuzione: TurnoDistribuzioneRecord) => {
        return distribuzione.tipoArrotondamento === 'DA_TABELLA';
    }

    static isArrotondamentoUscitaDaTabella = (distribuzione: TurnoDistribuzioneRecord) => {
        return distribuzione.tipoArrotondamentoUscita ? distribuzione.tipoArrotondamentoUscita === 'DA_TABELLA' : distribuzione.tipoArrotondamento === 'DA_TABELLA';
    }

    static isArrotondamentoInfragiornalieroDaTabella = (distribuzione: TurnoDistribuzioneRecord) => {
        return distribuzione.tipoArrotondamentoInfragiornaliero ? distribuzione.tipoArrotondamentoInfragiornaliero === 'DA_TABELLA' : distribuzione.tipoArrotondamento === 'DA_TABELLA';
    }


    static isArrotondamentoPausaDaTabella = (distribuzione: TurnoDistribuzioneRecord) => {
        return distribuzione.tipoArrotondamentoPausa === 'DA_TABELLA';
    }

    static getMinArrotondamentoPausa(that: TurnoDistribuzioneRecord) {
        return _getMinArrotondamento(that.tipoArrotondamentoPausa);
    }

    static getMinArrotondamento = function (that: TurnoDistribuzioneRecord) {
        return _getMinArrotondamento(that.tipoArrotondamento);
    };


    static getMinArrotondamentoUscita = function (that: TurnoDistribuzioneRecord) {
        return _getMinArrotondamento(that.tipoArrotondamentoUscita);
    };

    static getMinArrotondamentoInfragiornaliero = function (that: TurnoDistribuzioneRecord) {
        return _getMinArrotondamento(that.tipoArrotondamentoInfragiornaliero);
    };

    static getTotaleGiornata = function (turno: TurnoDistribuzioneRecord, durataIntervPrima: number, durataIntervSeconda: number, durataIntervTerza: number, durataIntervQuarta: number) {
        let totale = 0;
        totale += (durataIntervPrima + durataIntervSeconda + durataIntervTerza + durataIntervQuarta);
        totale = Math.round(totale * 100.0) / 100.0;

        if (turno.minMinutiPausa > 0 && turno.maxMinutiPausa > 0 && turno.decurtaPausa) {
            let minutiPausa;
            minutiPausa = turno.minMinutiPausa;
            let centesimi = Math.round(100 * minutiPausa / 60);
            centesimi /= 100.0;
            totale -= centesimi;
        }
        return totale;
    };

    static getDistribuzioneDescrizione = function (turno: TurnoDistribuzioneRecord) {
        const separatore = '&nbsp;<svg  xmlns="http://www.w3.org/2000/svg"  width="15"  height="15"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /></svg>&nbsp;';
        const iconaPausa = '&nbsp;<svg  xmlns="http://www.w3.org/2000/svg"  width="15"  height="15"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-tools-kitchen-3"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 4v17m-3 -17v3a3 3 0 1 0 6 0v-3" /><path d="M17 8m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0" /><path d="M17 12v9" /></svg>&nbsp;';

        const durataIntervPrima = turno.prima !== null ? CoppiaTimbrature.getDurataIntervallo(turno.prima) : 0;
        const durataIntervSeconda = turno.seconda !== null ? CoppiaTimbrature.getDurataIntervallo(turno.seconda) : 0;
        const durataIntervTerza = turno.terza !== null ? CoppiaTimbrature.getDurataIntervallo(turno.terza) : 0;
        const durataIntervQuarta = turno.quarta !== null ? CoppiaTimbrature.getDurataIntervallo(turno.quarta) : 0;
        const durataIntervPausa = turno.pausa !== null ? CoppiaTimbrature.getDurataIntervallo(turno.pausa) : 0;

        const prima = durataIntervPrima > 0 ? CoppiaTimbrature.getDescrizioneCoppia(turno.prima!) : '';
        const seconda = durataIntervSeconda > 0 ? CoppiaTimbrature.getDescrizioneCoppia(turno.seconda!) : '';
        const terza = durataIntervTerza > 0 ? CoppiaTimbrature.getDescrizioneCoppia(turno.terza!) : '';
        const quarta = durataIntervQuarta > 0 ? CoppiaTimbrature.getDescrizioneCoppia(turno.quarta!) : '';

        const pausa = durataIntervPausa > 0 ? CoppiaTimbrature.getDescrizioneCoppia(turno.pausa!) : '';

        let strisciata = prima;
        strisciata = strisciata + ((strisciata.length > 0 && seconda.length > 0) ? separatore : '') + seconda;
        strisciata = strisciata + ((strisciata.length > 0 && terza.length > 0) ? separatore : '') + terza;
        strisciata = strisciata + ((strisciata.length > 0 && quarta.length > 0) ? separatore : '') + quarta;

        strisciata = strisciata + ((strisciata.length > 0 && pausa.length > 0) ? iconaPausa + 'pausa di&nbsp;' + turno.minMinutiPausa + '\'&nbsp;' : '') + pausa;

        return TurnoDistribuzioneRecord.getTotaleGiornata(turno, durataIntervPrima, durataIntervSeconda, durataIntervTerza, durataIntervQuarta) === 0 ? 'n.p.' : strisciata;
    };
}